import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CountryDomainService } from './country-domain.service';
import { CountryFeature, isFeatureAvailable } from './country-features';

/**
 * Blocks routes of country-gated features (decision G8 in docs/backoffice-migration/README.md)
 * when the active country does not support them. Reads the country synchronously — a later switch
 * to an unsupported country while the page is already open is the page store's job to handle.
 */
export function countryFeatureGuard(feature: CountryFeature): CanActivateFn {
    return () => {
        const countryDomainService = inject(CountryDomainService);
        const router = inject(Router);

        return isFeatureAvailable(feature, countryDomainService.activeCountry)
            ? true
            : router.createUrlTree(['/']);
    };
}
